export const actionNames = {
  INIT_APP: 'SITE:INIT_APP',
  INIT_APP_SUCCESS: 'SITE:INIT_APP_SUCCESS',
  LEAVE_APP: 'SITE:LEAVE_APP',
  FETCH_SITE_SETTINGS: 'SITE:FETCH_SITE_SETTINGS',
  FETCH_SETTINGS_SUCCESS: 'SITE:FETCH_SETTINGS_SUCCESS',
  NOTIFICATION_SHOW: 'SITE:NOTIFICATION_SHOW',
  NOTIFICATION_HIDE: 'SITE:NOTIFICATION_HIDE',
  PERSISTENT_NOTIFICATION_SHOW: 'SITE:PERSISTENT_NOTIFICATION_SHOW',
  SHOW_CRITICAL_ERROR: 'SITE:SHOW_CRITICAL_ERROR',
  RESET_CRITICAL_ERROR: 'SITE:RESET_CRITICAL_ERROR',
  REFETCH_SITE_DATA: 'SITE:REFETCH_SITE_DATA',
  REFETCH_SITE_DATA_SUCCESS: 'SITE:REFETCH_SITE_DATA_SUCCESS',
}

export function showNotification(notification) {
  return {
    type: actionNames.NOTIFICATION_SHOW,
    notification,
  }
}

export function showPersistentNotification(notification) {
  return {
    type: actionNames.PERSISTENT_NOTIFICATION_SHOW,
    notification,
  }
}

export function resetCriticalError() {
  return {
    type: actionNames.RESET_CRITICAL_ERROR,
  }
}

export function initApp() {
  return {
    type: actionNames.INIT_APP,
  }
}

export function leaveApp() {
  return {
    type: actionNames.LEAVE_APP,
  }
}
